var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import Grid from '../../../components/UI/Grid/Grid';
import AppRoutes from '../../../config/appRoutes';
var BrandsList = /** @class */ (function (_super) {
    __extends(BrandsList, _super);
    function BrandsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.gridHeaders = [
            { name: 'Име', key: 'name', filter: false, sort: false },
            { name: 'Slug', key: 'slug', filter: false, sort: false },
            { name: 'Видим', key: 'Visible', filter: false, sort: false },
            { name: 'Позиция', key: 'position', filter: false, sort: false },
        ];
        _this.onPage = function (event) {
            _this.props.getAllBrands(event.page + 1);
        };
        _this.editProduct = function (rowItem) {
            var selectedId = _.get(rowItem, 'id', '0');
            if (selectedId !== '0') {
                _this.props.history.push(AppRoutes.editBrand.path.replace(':brandId', selectedId));
            }
        };
        return _this;
    }
    BrandsList.prototype.render = function () {
        var _a = this.props, gridData = _a.gridData, meta = _a.meta;
        return (React.createElement(Grid, { data: gridData, columns: this.gridHeaders, emptyMessage: "", paginator: true, lazy: true, total: _.get(meta, 'total_records', 0), rows: _.get(meta, 'per_page', 0), editAction: this.editProduct, onPage: this.onPage, first: (_.get(meta, 'current_page', 0) - 1) * _.get(meta, 'per_page', 0) }));
    };
    return BrandsList;
}(React.Component));
// @ts-ignore
export default withRouter(BrandsList);



//////////////////
// WEBPACK FOOTER
// ./src/components/Brands/BrandsList/BrandsList.tsx
// module id = 538
// module chunks = 0